import React from 'react';
import PropTypes from 'prop-types';
import {articleHref} from 'lib/categories';
import PhosphorIcon from '../icons/PhosphorIcon';
import styles from './article-list.module.scss';

const ArticleListItem = ({article}) => (
  <a className={styles.ArticleListItem} href={articleHref(article)}>
    <span className={styles.ArticleListItem__icon}>
      <PhosphorIcon name="fileText" size={18} />
    </span>
    <span className={styles.ArticleListItem__name}>{article.name}</span>
    <PhosphorIcon
      className={styles.ArticleListItem__arrow}
      name="arrowRight"
      size={16}
    />
  </a>
);

ArticleListItem.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};

export default ArticleListItem;



// WEBPACK FOOTER //
// ./src/components/articles/ArticleListItem.js